<template>
  <div class="graph-legend">
    <Pie
      :data="chartData"
      :options="chartOptions"
      class="pie-chart"
      data-test="pie-chart"
    />
    <div
      class="legend"
      data-test="legend"
    >
      <div
        v-for="(data, index) in chartData.labels"
        :key="`legend_${index}`"
        data-test="legend-item"
      >
        <div class="legend-row">
          <div class="legend-col">
            <span
              class="legend-color"
              :style="{
                backgroundColor: chartData.datasets[0].backgroundColor
                  ? chartData.datasets[0].backgroundColor[index]
                  : 'transparent',
              }"
              data-test="legend-color"
            ></span>
          </div>
          <div class="legend-col">
            <div
              class="legend-label"
              data-test="legend-label"
            >
              {{ data }}
            </div>
            <div
              class="legend-label-subheader"
              data-test="legend-label-subheader"
            >
              {{ htmlLegend[index] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue';
import { Pie } from 'vue-chartjs';
import filters from '@/helpers/filters';
import { useDonorStore } from '@/stores/DonorStore.js';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, CategoryScale } from 'chart.js';
ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

const donorStore = useDonorStore();

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  subheader: {
    type: Array,
    required: false,
  },
});

const htmlLegend = ref([]);

const chartData = ref({
  labels: [],
  datasets: [
    {
      backgroundColor: [],
      data: [],
    },
  ],
});

const chartOptions = ref({
  plugins: {
    legend: {
      display: false,
    },
  },
  layout: {
    padding: {
      bottom: 10,
    },
  },
});

onBeforeMount(() => {
  try {
    Object.values(props.data)
      .sort((a, b) => b.total_amount - a.total_amount)
      .forEach((item) => {
        chartData.value.labels.push(`${item.name}`);
        props.subheader
          ? htmlLegend.value.push(
              `${filters.formatMoney(item.total_amount)} across ${item.count} ${
                item.count === 1 ? props.subheader[0] : props.subheader[1]
              }`,
            )
          : '';
        chartData.value.datasets[0].data.push(item.total_amount);
      });
    let colors = donorStore.generateColors(Object.keys(props.data).length);
    chartData.value.datasets[0].backgroundColor = colors;
  } catch (error) {
    console.error('Error during onBeforeMount:', error);
  }
});
</script>
